/**
 * a3DetectionUtils.js
 *
 * Pure helper functions for detecting and pre-processing A3 summary messages.
 * Kept in a standalone module so they can be imported by both App.js and unit tests.
 */

/**
 * Returns true when a message is a full Executive A3 Summary document.
 *
 * Rules:
 *  - Starts with `## WHAT` (PPE agent format)
 *  - Starts with `**1. WHAT` (PROD legacy format)
 *  - Contains ≥3 distinct A3 section headings  (WHAT / WHERE / WHY / HOW / SUSTAIN)
 *    — prevents false-matches on agent menus that merely say "Generate Executive A3 Summary"
 */
export function isA3Message(text) {
  const t = (text || '').trimStart();
  // NOTE: do NOT short-circuit on t.startsWith('## WHAT') — the WHAT orchestrator
  // produces a standalone ## WHAT step response that must not be treated as a full A3.
  // The ≥3 section check correctly distinguishes a standalone WHAT from a full A3.
  const a3Sections = ['WHAT', 'WHERE', 'WHY', 'HOW', 'SUSTAIN'];
  const hits = a3Sections.filter((s) =>
    new RegExp(`(^|\\n)(##\\s*${s}|\\*\\*${s}\\*\\*|^${s}\\s*\\n)`, 'i').test(t)
  ).length;
  return hits >= 3;
}

/**
 * Strips the trailing agent navigation menu from A3 content before PDF generation.
 * Matches common closing phrases the agent appends after the A3 body.
 */
export function stripTrailingMenu(content) {
  const menuPattern =
    /\n(?:Would (?:we|you) like to|What would (?:we|you) like|Please respond with|Our problem-solving analysis is complete)[^\n]*/i;
  const idx = content.search(menuPattern);
  return idx > -1 ? content.slice(0, idx).trimEnd() : content;
}
